import { css, StyleSheet } from 'aphrodite'
import { cn } from '../utils/classname'
import Select, { Props as SelectProps } from 'react-select'
import { Field, FieldConfig } from 'formik'
import ValidationErrorMessage from './ValidationErrorMessage'
import { FieldProps } from 'formik/dist/Field'

export type Props = SelectProps & FieldConfig & {
    options?: Record<string, string>[]
    label?: string
    help?: string
    optional?: boolean
}

export default function MultiSelect({
    name,
    className,
    options,
    label,
    validate,
    help,
    optional,
    ...attributes
}: Props) {
    return (
        <div className="field">
            <div className="control">
                {label ? (
                    <label htmlFor={name}>
                        {label} &nbsp;
                        {optional ? <span className="form-hint">не обязательно</span> : null}

                        {help ? (
                            <p className={cn(css(styles.help), 'help has-text-grey-light')}>{help}</p>
                        ) : null}
                    </label>
                ) : null}

                <Field name={name} validate={validate}>
                    {({ form, field }: FieldProps<string>) => (
                        <Select
                            isMulti
                            className={className}
                            onBlur={() => form.setFieldTouched(name)}
                            value={field.value}
                            options={options}
                            {...attributes}
                            onChange={(values) => {
                                form.setFieldValue(name, values)
                            }} />
                    )}
                </Field>

                <ValidationErrorMessage name={name} />
            </div>
        </div>
    )
}

const styles = StyleSheet.create({
    help: {
        marginTop: '-2px',
    },
})
